import { render, staticRenderFns } from "./DetalleAlojamiento.vue?vue&type=template&id=f1647d92&scoped=true"
import script from "./DetalleAlojamiento.vue?vue&type=script&lang=js"
export * from "./DetalleAlojamiento.vue?vue&type=script&lang=js"
import style0 from "./DetalleAlojamiento.vue?vue&type=style&index=0&id=f1647d92&prod&scoped=true&lang=scss"
import style1 from "../../components/DetalleAlojamiento/ficha/ficha.css?vue&type=style&index=1&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1647d92",
  null
  
)

export default component.exports